export default "__VITE_ASSET__CUJvJCJR__"